export function cleanPhoneCountryCode(v: string) {
  /* remove trailing zeroes and + */
  return v.replace(/^[0+]+/, '');
}
